import { useQuery } from "@tanstack/react-query"
import { fetchServerDate, fetchSupplierById, fetchAllClients, fetchSupplierUsers, fetchUsername } from "../services/suppliersProfile.service"

export const useSupplierProfileData = ({ id, userLogged }) => {
	const serverDateQuery = useQuery({
		queryKey: ['serverDate'],
		queryFn: fetchServerDate,
		enabled: !!id && !!userLogged,
	})

	const supplierQuery = useQuery({
		queryKey: ['supplier-supplierProfile', id],
		queryFn: () => fetchSupplierById(id, { dataID: userLogged?.dataID, rol: userLogged?.rol }),
		enabled: !!id && !!userLogged,
	})

	const clientsQuery = useQuery({
		queryKey: ['clients-supplierProfile'],
		queryFn: fetchAllClients,
		enabled: !!id && !!userLogged,
	})

	const usersQuery = useQuery({
		queryKey: ['supplierUsers-supplierProfile', id],
		queryFn: () => fetchSupplierUsers(id),
		enabled: !!id && !!userLogged,
	})

	const usernameQuery = useQuery({
		queryKey: ['username-supplierProfile', id],
		queryFn: () => fetchUsername(id),
		enabled: !!id && !!userLogged,
	})

	const isLoading = serverDateQuery.isLoading || supplierQuery.isLoading || clientsQuery.isLoading || usersQuery.isLoading || usernameQuery.isLoading

	return {
		supplierData: supplierQuery.data,
		serverDate: serverDateQuery.data,
		clients: clientsQuery.data,
		users: usersQuery.data ?? [],
		username: usernameQuery.data,
		isLoading,
	}
}
